export const ignoredSentryErrors = [
  'Failed to fetch dynamically imported module',
  "Failed to execute 'removeChild' on 'Node'",
  "Failed to execute 'insertBefore' on 'Node'",
  'ResizeObserver loop limit exceeded',
  'Importing a module script failed.',
];
